import { PropsWithChildren } from "react";
import { getRumSession } from "./rumSession";
import { MonitoringContext } from "./useMonitoring";
import { AwsRum } from "aws-rum-web";

export const MonitoringProvider = ({
  children,
}: PropsWithChildren<unknown>) => {
  const { awsRum, sessionId } = getRumSession();

  const updateMonitoringPrincipalId = (principalId: string) => {
    awsRum?.addSessionAttributes({
      principalId: principalId,
    });
  };

  return (
    <MonitoringContext.Provider
      value={{
        awsRum: awsRum as AwsRum,
        updateMonitoringPrincipalId,
        sessionId,
      }}
    >
      {children}
    </MonitoringContext.Provider>
  );
};
